import type { OrientationType } from './Orientation';

export interface AdviceChoice {
  readonly handlingFee: number;
  readonly adviceCosts: number;
  readonly currentChoice: AdviceChoiceValue;
  readonly type: OrientationType;
  readonly orientationUri: string | undefined;
  readonly choiceOptions: AdviceChoiceOptions;
}

export enum AdviceChoiceValue {
  ExecutionOnly = 'ExecutionOnly',
  WithAdvice = 'WithAdvice'
}

export enum AdviceChoiceOptions {
  WithAdvice = 'WithAdvice',
  None = 'None',
  All = 'All'
}
